<p>tip-pool-setup works!</p>
